import script from "./controller.vue?vue&type=script&lang=ts&setup=true"
export * from "./controller.vue?vue&type=script&lang=ts&setup=true"

import "./controller.vue?vue&type=style&index=0&id=2ab451b5&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2ab451b5"]])

export default __exports__